import { cloneDeep } from 'lodash-es';
import {
  currentOrPastDateUI,
  fullNameNoSuffixSchema,
  fullNameNoSuffixUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  currentYear,
  parseISODate,
} from 'platform/forms-system/src/js/helpers';
import { isValidDate } from 'platform/forms-system/src/js/utilities/validations';
import {
  veteranFields,
  veteranInformationText,
} from '../definitions/constants';

const veteranFullNameUI = cloneDeep(fullNameNoSuffixUI());
veteranFullNameUI.first['ui:title'] = veteranInformationText.firstNameTitle;
veteranFullNameUI.first['ui:errorMessages'] = {
  required: veteranInformationText.firstNameError,
};
veteranFullNameUI.middle['ui:title'] =
  veteranInformationText.middleInitialTitle;
veteranFullNameUI.last['ui:title'] = veteranInformationText.lastNameTitle;
veteranFullNameUI.last['ui:errorMessages'] = {
  required: veteranInformationText.lastNameError,
};

const veteranFullNameSchema = cloneDeep(fullNameNoSuffixSchema);
if (veteranFullNameSchema?.properties?.middle) {
  veteranFullNameSchema.properties.middle.maxLength = 1;
}

const validateDateOfBirth = (errors, value) => {
  const { day, month, year } = parseISODate(value);
  const hasAnyDatePart = [day, month, year].some(Boolean);
  const hasCompleteDate = [day, month, year].every(Boolean);

  if (!value || !hasAnyDatePart) {
    errors.addError(veteranInformationText.dateOfBirthRequiredError);
    return;
  }

  if (!hasCompleteDate) {
    errors.addError(veteranInformationText.dateOfBirthIncompleteError);
    return;
  }

  if (
    Number(year) < 1900 ||
    Number(year) > currentYear ||
    !isValidDate(day, month, year)
  ) {
    errors.addError(veteranInformationText.dateOfBirthPatternError);
  }
};

export default {
  uiSchema: {
    ...titleUI(
      veteranInformationText.pageTitle,
      veteranInformationText.pageDescription,
    ),
    'ui:options': { preserveHiddenData: true, forceDivWrapper: true },
    [veteranFields.parentObject]: {
      [veteranFields.fullName]: veteranFullNameUI,
      [veteranFields.dateOfBirth]: {
        ...currentOrPastDateUI({
          title: veteranInformationText.dateOfBirthTitle,
          required: () => true,
          errorMessages: {
            required: veteranInformationText.dateOfBirthRequiredError,
            pattern: veteranInformationText.dateOfBirthPatternError,
          },
        }),
        'ui:errorMessages': {
          required: veteranInformationText.dateOfBirthRequiredError,
          pattern: veteranInformationText.dateOfBirthPatternError,
        },
        'ui:validations': [validateDateOfBirth],
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      [veteranFields.parentObject]: {
        type: 'object',
        properties: {
          [veteranFields.fullName]: veteranFullNameSchema,
          [veteranFields.dateOfBirth]: { type: 'string' },
        },
        required: [veteranFields.fullName, veteranFields.dateOfBirth],
      },
    },
  },
};
